import { createFileRoute, redirect } from '@tanstack/react-router'
import { SignUp } from '@/features/auth/sign-up'
import { getSession } from '@/lib/auth-client'

export const Route = createFileRoute('/(auth)/sign-up')({
  beforeLoad: async () => {
    const session = await getSession()
    if (session.data) {
      // Already logged in, redirect to dashboard
      throw redirect({
        to: '/',
      })
    }
  },
  component: SignUp,
})
